import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Container, Grid, Box, Typography } from "@mui/material";
import { get_post_by_id_public } from "../../Redux/Actions/action";
import { showLoader } from "../../Redux/Slices/loaderSlice";

export default function EventDetails() {
    const bucketUrl = 'https://webitodevelopment.s3.ap-south-1.amazonaws.com/';
    const { id } = useParams();
    const dispatch = useDispatch();
    const [eventData, setEventData] = useState(null);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        const fetchData = async () => {
            dispatch(showLoader(true));
            try {
                const res = await dispatch(get_post_by_id_public({
                    _id: id
                }));
                setEventData(res?.payload?.data?.post?.eventDetails || res?.payload?.data || null);
                dispatch(showLoader(false));
            } catch (err) {
                console.error(err);
                dispatch(showLoader(false));
            }
        };
        fetchData();
    }, [dispatch, id]);

    if (!eventData) return <Typography>Loading...</Typography>;

    return (
        <>
            <Container sx={{ mt: { lg: '60px', md: '60px', sm: "40px", xs: '20px' }, mb: '20px' }}>
                <Typography
                    color={"primary"}
                    sx={{
                        fontSize: { lg: "44px", md: "30px", sm: "26px", xs: "20px" },
                        fontWeight: "bold",
                        marginBottom: { lg: "40px", md: "30px", sm: "26px", xs: "20px" },
                        textAlign: 'center'
                    }}
                >
                    {eventData.eventName}
                </Typography>
                <Box
                    sx={{
                        display: 'flex',
                        gap: { lg: '30px', sx: "12px" },
                        flexWrap: { lg: 'nowrap', md: 'wrap' },
                        alignItems: 'start',
                        justifyContent: 'space-between'
                    }}
                >
                    <Typography
                        variant="h6"
                        sx={{
                            fontSize: { lg: "22px", md: "20px", sm: "16px", xs: "16px" },
                            marginBottom: { lg: '12px', md: '12px' },
                        }}
                    >
                        {eventData?.description || 'Untitled Event'}
                    </Typography>
                    <Typography
                        variant="body2"
                        color="text.secondary"
                        mb={1}
                        sx={{ fontSize: { lg: "18px", md: "14px", sm: "14px", xs: "14px" } }}
                        whiteSpace={'nowrap'}
                    >
                        {eventData?.date ? new Date(eventData.date).toLocaleDateString('en-IN', {
                            day: 'numeric',
                            month: 'short',
                            year: 'numeric'
                        }) : ''}{" "}
                        {eventData?.time ? `| ${eventData.time}` : ''}
                    </Typography>
                </Box>
                <Grid container spacing={2}>
                    {eventData.eventImage?.map((img, index) => {
                        const rowNumber = Math.floor(index / 3);
                        const isOddRow = rowNumber % 2 === 0;
                        return (
                            <Grid
                                item
                                xs={12}
                                sm={6}
                                md={isOddRow ? 3 : 4}
                                key={index}
                            >
                                <Box
                                    component="img"
                                    src={bucketUrl + img}
                                    alt={`Event Image ${index + 1}`}
                                    sx={{ width: '100%', height: 'auto', borderRadius: '20px' }}
                                />
                            </Grid>
                        );
                    })}
                </Grid>
            </Container>
        </>
    );
}
